import { ActiveCart, ActiveCartGiftWithPurchases } from 'types/cart';
import { ProductCartItem, Size, VariantProduct } from '__generated__/graphql';

import { SelectedItemType } from '../types';

export const selectedItemsInCart = (
  cart: ActiveCart,
  findSizeObjectCallback: (item: VariantProduct) => Size,
  giftWithPurchase?: ActiveCartGiftWithPurchases
): SelectedItemType[] => {
  if (!cart?.products || !giftWithPurchase) return [];
  // Filter all products in cart to return ProductCartItem types that also
  // match the selected giftWithPurchase.id then map them to SelectedItemType.
  return cart.products
    .filter(
      product =>
        product.__typename === 'ProductCartItem' &&
        product.bonusItemId === giftWithPurchase.id
    )
    .map(_gift => {
      const gift = _gift as ProductCartItem;
      return {
        color: gift.product.colorValue,
        colorName: gift.product.colorName,
        id: gift.product.masterId,
        productName: gift.product.name,
        quantity: gift.quantity,
        size: findSizeObjectCallback(gift.product),
      };
    });
};
